<template>
  <v-card>
        <div style='background-color:rgba(255, 255, 255);'>
          <div>
            <v-row>
              <div
                style="width:100%;"
                class="d-flex align-center justify-space-around"
              >
                <span>
                  <v-icon color="#e858ff">mdi-alarm-light-outline</v-icon>
                  пучок : {{workload_ms > 0 ? workload_ms : 0}} часов
                  <br />
                </span>
                <span>
                  <v-icon color="#15336D">mdi-alarm-check</v-icon>
                  заявки : {{workload_proposals > 0 ? workload_proposals : 0}} часов
                  <br />
                </span>
                <span>
                  <v-icon color="green">mdi-shield-home-outline</v-icon>
                  in-house : {{workload_inhouse > 0 ? workload_inhouse : 0}} часов
                  <br />
                </span>
               </div>
            </v-row>
            <v-row v-if="not_distributed_count > 0">
              <v-col cols="4" class="pa-0 pt-1">
              </v-col>
              <v-col cols="8" class="pa-0 pt-1">
                <span>
                  <v-icon color="red">mdi-alert-circle</v-icon>
                  не распределено заявок : {{ not_distributed_count }} на {{not_distributed > 0 ? not_distributed : 0}} часов
                  <br />
                </span>
              </v-col>
            </v-row>
          </div>

          <v-sheet
              style="padding: 0 15px;"
              tile
              height="54"
              class="d-flex align-center justify-space-between"
          >
              
          <div
              class="d-flex align-center"
          >
            <v-btn
                fab
                text
                small
                color="grey darken-2"
                @click="prev"
              >
                <v-icon small>
                  mdi-chevron-left
                </v-icon>
              </v-btn>
          
            <v-btn
              outlined
              x-small
              :color="$mainColor"
              @click="to_today"
            >
              сегодня
            </v-btn>

            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="next"
               mr-auto
           >
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>

          </div>


            <v-btn
              rounded
              color="primary"
              small
            >
              {{ current_month }}
              {{ current_year }}
            </v-btn>

          <div
              class="d-flex align-center"
          >
            
            <template v-for='filter_date in filters'>
              <v-btn
                  v-if='filter_date.slug===type_view'
                  class='ml-1'
                  x-small
                  :color="$mainColor"
                  style='color:white'
                  @click="change_vies(filter_date.slug)"
              >
                  {{filter_date.name}}
              </v-btn>

              <v-btn
                  v-else
                  outlined
                  class='ml-1'
                  x-small
                  :color="$mainColor"
                  @click="change_vies(filter_date.slug)"
              >
                  {{filter_date.name}}
              </v-btn>
            </template>
          </div>
          </v-sheet>
            
          <v-calendar
            style='min-height:600px; width:100%; background-color:rgba(250, 242, 160, 40%);'
            :now="today"
            :value="current_cal_date"
            :type='type_view'
            :event-color="getEventColor"
            :first-time="first_time"
            :locale="locale"
            :event-more=false
            :weekdays="weekdays"
            :events="events"
            @click:event="openPopupCard_d"
          >
          </v-calendar>

          <v-dialog v-if="popup_data.type != 3 && popup_data.type != 4"
          v-model="dialogCalendarCard"
          width="60%">
          <calendar-card
            @updateParent="update_parent($event)" 
            @closeModal="close_modal($event)" 
            :InputData="popup_data"
          />
          </v-dialog>

          <v-dialog  v-if="popup_data.type == 3 || popup_data.type == 4"
            v-model="dialogCalendarCard"
            width="360px"
          >
          <calendar-ms-card
            @updateParent="update_parent_ms($event)" 
            :InputData="popup_data"
            :add_new="is_add_new_ms"
          />

          </v-dialog>
        </div>
    
  </v-card>



</template>


<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import CalendarCard from '../Modal/CalendarCard.vue'
import CalendarMsCard from '../Modal/CalendarMSCard.vue'

  export default {
    props: {
      input_station_id: Number,
    },
    data: () => ({
      calendar_date: null,
      current_month: '',
      current_year: '',
      current_cal_date: '2025-01-01',
      today: '2021-02-15',
      weekdays: [1, 2, 3, 4, 5, 6, 0],
      first_time: "8:00",
      locale: "ru-ru",
      dialogCalendarCard: false,
      type_view: 'month',
      popup_data:{
        name:  null,
        currentStations: null,
        nameCard: null,
        listDate: null,
        comment: null,
        author: null,
        typeApp: null,
        idExperiment: null,
      },
      filters: [
          {name:'месяц',slug:'month'},
          {name:'неделя',slug:'week'},
          // {name:'4 дня',slug:'4day'}
      ],
      events: [],
      is_init: false,
      menus: [
        {name:'Общая статистика',id: 1, disabled:false, icon:'mdi-chart-pie'},
        {name:'Оперативные журналы',id: 2, disabled:true, icon:'mdi-clock-fast'},
      ],
      current_station_id: null,
      current_station: null,
      ms_working_events: [],
      react_working_events: [],
      sinch_working_events: [],
      station_type: null,
      workload_proposals: 0,
      workload_inhouse: 0,
      workload_ms: 0,
      not_distributed: 0,
      not_distributed_count: 0,
      is_add_new_ms: false,
       
    }),

    async beforeMount() {
      this.calendar_date = new Date()
      this.update_curr()
      this.load_ms_calendar()

      if(this.input_station_id > 0){
        this.current_station_id = this.input_station_id
        if(this.GETTERS_CALENDAR_INIT){
          this.load_calendar()
        }
      }
    },

    components:{
      CalendarCard, CalendarMsCard
    },

    computed:{
        ...mapGetters([
          'GETTERS_STATION_CALENDAR',
          'GETTERS_CALENDAR_INIT',
          'GETTERS_CURRENT_STATION',
          'GETTERS_UPDATE_CURRENT_CALENDAR',
          'GETTERS_CURRENT_USER',
          'GETTERS_STATION_BY_ID',
        ]),        
    },

    watch:{
      GETTERS_UPDATE_CURRENT_CALENDAR(val){
        if(val){
          this.load_calendar()
          this.UPDATE_CURRENT_CALENDAR(false)
        }
      },

      GETTERS_CURRENT_STATION(val){
        if(val){
          this.current_station_id = val
          this.load_calendar()
        }
      },

      GETTERS_CALENDAR_INIT(val) {
        if(val){
          this.load_calendar();
        }
      },
    },

    methods:{
      ...mapActions([ 
        'GET_CALENDAR_LIST',
        'GET_CALENDAR_MS_LIST',
        'GET_STATION_WORKLOAD',
      ]),
      ...mapMutations([
        'UPDATE_CURRENT_CALENDAR',
        'UPDATE_OVERLAY',
      ]),

      load_ms_calendar(){
        this.sinch_working_events = []
        this.react_working_events = []
        this.GET_CALENDAR_MS_LIST()
        .then((res) => {
          res.data.forEach(event => {
            if(event.type == 3)
              this.sinch_working_events.push({
                name:  'пучок КИСИ' ,
                start: this.formate_date_for_cal(event.start_date, true),
                end: this.formate_date_for_cal(event.finish_date, false),
                source: event,
                id: event.id,
                type: event.type,
              })                  

            else if(event.type == 4)
              this.react_working_events.push({
                name:  'пучок ИP-8' ,
                start: this.formate_date_for_cal(event.start_date, true),
                end: this.formate_date_for_cal(event.finish_date, false),
                source: event,
                id: event.id,
                type: event.type,
              })                  
          })
        })
      },

      get_workload(){
        var d = this.calendar_date
        var mm = d.getMonth() + 1
        var yy = d.getFullYear()
        if(mm < 10)
          mm = '0' + mm.toString()

        var args = {
          station_id: this.current_station_id,
          start: yy + '-' + mm + '-01'
        }

        this.workload_proposals = 0
        this.workload_inhouse = 0
        this.workload_ms = 0
        this.not_distributed = 0
        this.not_distributed_count = 0

        this.GET_STATION_WORKLOAD(args)
        .then((res) => {
          this.workload_proposals = res.data.proposals/3600
          this.workload_inhouse = res.data.inhouse/3600
          this.workload_ms = res.data.ms_working_time/3600
          this.not_distributed = res.data.not_distributed
          this.not_distributed_count = res.data.not_distributed_count
        })
      },

      async load_calendar(){
        if(this.current_station_id > 0){
          this.GET_CALENDAR_LIST({station_id:this.current_station_id})
          .then(() => {
            this.update_events();
          })
        }
      },

      update_events(){
        if(this.current_station_id > 0){
          var res = this.GETTERS_STATION_CALENDAR(this.current_station_id);
          if(res.loaded){
            this.events = []
            if(this.station_type == 1){
              this.sinch_working_events.forEach(event => {
                this.events.push(event)
              })
            }
            else if(this.station_type == 2){
              this.react_working_events.forEach(event => {
                this.events.push(event)
              })
            }

            res.calendars.forEach(calendar_item => {
              var name = ''
              if(calendar_item.type == 2 || calendar_item.type == 5){
                name = calendar_item.proposal_id + ' ' + calendar_item.proposal_applicant
              }
              else{
                name = calendar_item.experiment_name ??  'без названия'
              }

              this.events.push({
                name:  name ,
                start: this.formate_date_for_cal(calendar_item.start_date, true),
                end: this.formate_date_for_cal(calendar_item.finish_date, false),
                source: calendar_item,
                id: calendar_item.id,
                type: calendar_item.type,
              })                  
            })
          }
          else{
            this.load_calendar()
          }
        }
      },

      formate_date_for_cal(str, with_one){
        var dd_cal = new Date(str)
        var min = dd_cal.getMinutes()
        if (min === 0 && with_one) min = '1'
        const formatted = `${dd_cal.getFullYear()}-${(dd_cal.getMonth()+1)}-${dd_cal.getDate()} ${dd_cal.getHours()}:${min}`
        return formatted
      },

      async openPopupCard_d({ nativeEvent, event }) {
        if((event.type == 3 || event.type == 4))
          return;
        this.popup_data = event
        this.is_add_new_ms = false
        this.dialogCalendarCard =true
      },

      to_today(){
        this.calendar_date = new Date()
        this.update_curr()
      },

      getEventColor(event) {
          if (event.type == 0) // 'обслуживание станции'
            return '#00ffda'
          else if (event.type == 2)  // proposal
            return '#15336D'
          else if (event.type == 1) // 'in-house'
            return 'green'
          else if (event.type == 3) // пучок КИСИ
            return '#e858ff'
          else if (event.type == 4) // пучок ИP-8
            return '#e858ff'
          else if (event.type == 5)  // proposal draft
            return '#0fa7c8e6'
          else
            return  'red'
      },
      
      prev () {
        if(this.type_view == 'month'){
          this.calendar_date.setMonth(this.calendar_date.getMonth() - 1)
        }
        else if(this.type_view == 'week'){
          this.calendar_date.setDate(this.calendar_date.getDate() - 7)
        }

        this.update_curr()
      },
      
      next () {
        if(this.type_view == 'month'){
          this.calendar_date.setMonth(this.calendar_date.getMonth() + 1)
        }
        else if(this.type_view == 'week'){
          this.calendar_date.setDate(this.calendar_date.getDate() + 7)
        }

        this.update_curr()
      },
      
      update_curr(){
        var mm = this.calendar_date.getMonth() + 1;
        var dd = this.calendar_date.getDate();
        var yy = this.calendar_date.getFullYear();

        this.current_cal_date =  yy + '-' + mm + '-' + dd; //(US)

        var t = 'month.' + mm 
        this.current_month = this.$t(t)
        this.current_year = this.calendar_date.getFullYear();

        this.get_workload()
      },

      change_vies(type){
          this.type_view = type
      },

      show_calendar(){
        this.UPDATE_OVERLAY(true)

        if(!this.events){
          this.update_events()
            .then(() => {
              this.show_calendar();
            })
        }
        else
          this.UPDATE_OVERLAY(false)
      },

      update_parent() {
        this.load_calendar()
        this.dialogCalendarCard =false
      },

      update_parent_ms() {
        this.load_ms_calendar()
        this.dialogCalendarCard =false
      },

      close_modal(){
        this.dialogCalendarCard = false
      },
    },

    mounted () {
      var d = new Date()
      this.calendar_date = new Date()
      this.today = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
    },
  }
</script>


<style scoped>
.v-event {
  height: 40px;
}
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #1867c0;
  color: #ffffff;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;
}
  
.my-event.with-time {
  position: absolute;
  right: 4px;
  margin-right: 0px;
}
  .btn-calendar-completed{
    background: #15336d;
    border-radius: 15px;
    color:white;
    padding: 15px 20px;
  }
</style>